import { call, put, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { notification } from 'antd';
import {
  BulkDeleteFilesAction,
  setFileList,
  setFolderList,
  setSelectedFile,
  setSelectedItems,
  setState,
} from '../actions';
import api from '../../../../../../services/api';
import { getCompanyLibrary } from '../selectors';
import { CompanyLibraryState } from '../reducers';
import { updateRelations } from './uploadFileWorker';

export function* bulkDeleteFilesWorker(action: BulkDeleteFilesAction) {
  const { fileIDs, folderIDs } = action.payload;

  yield put(setState({ isLoadingList: true }));

  const { fileList, folderList, loadMoreAvailable } = (yield select(
    getCompanyLibrary,
  )) as CompanyLibraryState;

  try {
    if (fileIDs.length > 0 && folderIDs.length === 0) {
      yield call(api.delete, `/v1/company-library/batch-delete-files`, { data: { fileIds: fileIDs } });
    } else if (folderIDs.length > 0 && fileIDs.length === 0) {
      yield call(api.delete, `/v1/company-library/batch-delete-folders`, { data: { folderIds: folderIDs } });
    } else if (fileIDs.length > 0 && folderIDs.length > 0) {
      yield call(api.delete, `/v1/company-library/batch-delete`, { data: { folderIds: folderIDs, fileIds: fileIDs } });
    }

    const newFileList = fileList.filter(file => !fileIDs.includes(file.ID));
    yield put(setFileList(newFileList, loadMoreAvailable));

    const newFolderList = folderList.filter(folder => !folderIDs.includes(folder.ID));
    yield put(setFolderList(newFolderList, loadMoreAvailable));

    yield put(setSelectedFile(null));

    yield put(setSelectedItems([]));

    yield call(updateRelations);

    notification.success({
      message: 'Success',
      description: `Successfully deleted ${fileIDs.length + folderIDs.length} item(s).`,
    });
  } catch (err) {
    Sentry.captureMessage(`Error bulk deleting files: ${err}`);
    notification.error({
      message: 'Error',
      description:
        'There was an error deleting the selected items. Please try again or contact support.',
    });
  } finally {
    yield put(setState({ isLoadingList: false }));
  }
}
